import React, { type ReactNode } from "react";
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withSequence,
  withTiming,
} from "react-native-reanimated";

const ANGLE = 10;

export const AnimationWiggle: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const rotation = useSharedValue(0);

  React.useEffect(() => {
    rotation.value = withRepeat(
      withSequence(
        withTiming(-10, { duration: 200 }),
        withRepeat(withTiming(ANGLE, { duration: 200 }), 4, false),
        withTiming(0, { duration: 200 }),
      ),
      -1,
      false,
    );
  }, [rotation]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      transform: [{ rotate: `${rotation.value}deg` }],
    };
  });

  return <Animated.View style={[animatedStyle]}>{children}</Animated.View>;
};
